<template>
  <div>
    <p class="text-muted mb-1">
      {{ $t('Deixe a abertura e o fechamento vazios para indicar que a loja fica fechada no dia.') }}
    </p>

    <!-- Cabeçalho das colunas (só em telas médias+). -->
    <b-row class="d-none d-md-flex text-muted font-small-3 font-weight-bold mb-25">
      <b-col md="3">
        {{ $t('Dia') }}
      </b-col>
      <b-col md="3">
        {{ $t('Abre') }}
      </b-col>
      <b-col md="3">
        {{ $t('Fecha') }}
      </b-col>
      <b-col md="3" />
    </b-row>

    <b-row
      v-for="day in days"
      :key="day.dayOfWeek"
      align-v="center"
      class="opening-hours-row"
    >
      <b-col
        md="3"
        class="mb-50 mb-md-0"
      >
        <strong>{{ dayLabel(day.dayOfWeek) }}</strong>
      </b-col>
      <b-col md="3">
        <FormulateInput
          :id="`opening-${day.dayOfWeek}-start`"
          v-model="day.openingTime"
          type="text-mask"
          :mask="['##:##']"
          :name="`opening_${day.dayOfWeek}_start`"
          placeholder="--:--"
          class="mb-0"
        />
      </b-col>
      <b-col md="3">
        <FormulateInput
          :id="`opening-${day.dayOfWeek}-end`"
          v-model="day.closingTime"
          type="text-mask"
          :mask="['##:##']"
          :name="`opening_${day.dayOfWeek}_end`"
          placeholder="--:--"
          class="mb-0"
        />
      </b-col>
      <b-col
        md="3"
        class="mb-50 mb-md-0"
      >
        <span
          v-if="isClosed(day)"
          class="text-muted font-small-2"
        >
          {{ $t('Fechado') }}
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { storeDomains } from '@/mixins'

/**
 * Grade dos sete dias (dom → sáb) da tela dedicada de "Horários de Funcionamento" (D27).
 *
 * Cada dia tem a janela de atendimento (`openingTime`/`closingTime`). Um dia com ambos os campos
 * vazios significa "fechado" — não há botão dedicado, apenas o rótulo "Fechado" quando a janela
 * está vazia. No escopo de loja o horário efetivo é tudo-ou-nada (próprio-ou-Geral, D27): uma
 * loja com horário próprio precisa cadastrar todos os dias em que abre.
 */
export default {
  components: {
    BRow,
    BCol,
  },

  mixins: [storeDomains],

  props: {
    // Lista dos sete dias em edição (mesma referência do estado Vuex; mutada via v-model).
    days: {
      type: Array,
      required: true,
    },
  },

  computed: {
    dayLabelMap() {
      return this.dayOfWeekOptions().reduce((acc, option) => {
        acc[option.value] = option.label
        return acc
      }, {})
    },
  },

  methods: {
    dayLabel(dayOfWeek) {
      return this.dayLabelMap[dayOfWeek] || dayOfWeek
    },

    // Dia fechado = sem abertura e sem fechamento.
    isClosed(day) {
      return !day.openingTime && !day.closingTime
    },
  },
}
</script>

<style scoped>
.opening-hours-row {
  padding: 0.35rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.opening-hours-row:last-child {
  border-bottom: 0;
}
</style>
